import React from "react";
import CustomSpinner from "../Spinner/Spinner";
import { Modal } from "../CustomModal/Modal";
import Popup from "../Popup/Popup";

//css
import "./TopNavigationBar.scss";

//constants
import { Strings } from "../../Resources/Strings/i18n";

//resources
import AllWellLogoImg from "../../Resources/Images/img_logo.png";
import Button from "@material-ui/core/Button";
import ic_google_play from "../../Resources/Images/ic_google_play.png";
import ic_app_store from "../../Resources/Images/ic_app_store.png";
import img_app_store from "../../Resources/Images/img_app_store.png";
import img_google_play from "../../Resources/Images/img_google_play.png";
import { Divider } from "@material-ui/core";
import { PATHS } from "../../Constants";
import { withRouter } from "react-router-dom";
import { LoginAction } from "../Login/LoginAction";
import ErrorModal from "../ErrorModal/ErrorModal";
import { OperationStatus, APIResponse } from "../../Communication/Constants";
import { googleLogout } from "@react-oauth/google";

class TopNavigationBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInstallAppModal: false,
      showSpinner: false,
      showErrorModal: false,
      errorMessage: "",
      showCustomModal: false,
    };
    this.loginAction = new LoginAction();
  }
  hideModal = () => {
    this.setState({
      showInstallAppModal: false,
    });
  };

  fetchLoggedInUserDetails() {
    if (
      this.props.inviteTokenInfo &&
      this.props.inviteTokenInfo.isInvitedUser
    ) {
      let { first_name, last_name } = this.props.invitedUserInfo.invitee || {};
      this.invitedFirst_name = first_name || "";
      this.invitedLast_name = last_name || "";
      this.invitedFull_name =
        (first_name
          ? first_name[0].toUpperCase() + first_name.substring(1)
          : "") +
        " " +
        (last_name ? last_name[0].toUpperCase() + last_name.substring(1) : "");
    } else {
      let { first_name, last_name } = this.props.userInfo || {};
      this.first_name = first_name || "";
      this.last_name = last_name || "";
      this.full_name =
        (first_name
          ? first_name[0].toUpperCase() + first_name.substring(1)
          : "") +
        " " +
        (last_name ? last_name[0].toUpperCase() + last_name.substring(1) : "");
    }
  }

  render() {
  this.fetchLoggedInUserDetails()
    return (
      <div className="TopNavigationBar">
        <CustomSpinner showModal={this.state.showSpinner} />

        {/* error modal */}
        <div>
          {this.state.showErrorModal ? (
            <ErrorModal
              showErrorModal={this.state.showErrorModal}
              errorMessage={this.state.errorMessage}
              history={this.props.history}
              setShowErrorModal={(value) =>
                this.setState({ showErrorModal: value })
              }
            />
          ) : null}
        </div>

        <Popup
          heading="Logout"
          content="Are you sure you want to logout?"
          showCustomModal={this.state.showCustomModal}
          setShowCustomModal={(value) =>
            this.setState({ showCustomModal: value })
          }
          funOnSuccess={() => {
            localStorage.removeItem("myState");
            this.setState({ showSpinner: true });

            this.loginAction.logout((actionCallback) => {
              if (actionCallback.status === OperationStatus.SUCCESS) {
                this.setState({ showSpinner: false });
                googleLogout()
                this.props.logout();
                this.props.history.push("/home");
              } else {
                if (
                  actionCallback.error.errorCode ===
                  APIResponse.INVALID_USER_PROFILE
                ) {
                  this.setState({ showSpinner: false });
                  this.setState({
                    errorMessage: Strings("ERROR_INVALID_USER_PROFILE"),
                  });
                  this.setState({ showErrorModal: true });
                } else if (
                  actionCallback.status ===
                  OperationStatus.NETWORK_NOT_REACHABLE
                ) {
                  this.setState({ showSpinner: false });
                  this.setState({
                    errorMessage: Strings("NetworkNotReachable"),
                  });
                  this.setState({ showErrorModal: true });
                } else if (
                  actionCallback.error.errorCode === APIResponse.TOKEN_MISMATCH
                ) {
                  this.setState({ showSpinner: false });
                  this.setState({ errorMessage: Strings("Token mismatch") });
                  this.props.logout();
                    this.props.history.push("/home")
                } else if (
                  actionCallback.error.errorCode ===
                  APIResponse.TOKEN_INFO_NOT_FOUND
                ) {
                  this.setState({ showSpinner: false });
                  this.setState({
                    errorMessage: Strings(
                      "Token info not found for current user"
                    ),
                  });
                  this.props.logout();
                  this.props.history.push("/home")
                } else {
                  this.setState({ showSpinner: false });
                  this.setState({
                    errorMessage: actionCallback.error.errorMessage,
                  });
                  this.setState({ showErrorModal: true });
                }
              }
            });
          }}
          leftbtn={Strings("cancel")}
          rightbtn={Strings("YES")}
        />

        <div>
          {this.state.showInstallAppModal ? (
            <Modal
              show={this.state.showInstallAppModal}
              handleClose={this.hideModal}
              parent={"login"}
            >
              {
                <div className="appInstallModal">
                  <div className="errorOtp">
                    <div className="errorModal">
                      <div className="modalTitle">
                        <p id="errorTitle">
                          <span id="errorText">{Strings("InstallApp")}</span>
                        </p>
                      </div>
                      <div className="errorContainer">
                        <div className="errorContent">
                          <p>{Strings("InstallAppInfo")}</p>
                          <div>
                            <a
                              //href="https://allwellapp.com/free"
                              onClick={() => {
                                window.open(
                                  "https://allwellapp.com/free",
                                  "_self"
                                );
                                setTimeout(() => {
                                  this.setState({
                                    showInstallAppModal: false,
                                  });
                                }, 100);
                              }}
                            >
                              <img
                                src={img_google_play}
                                alt={img_google_play}
                              />
                            </a>
                            <a
                              //href="https://allwellapp.com/free"
                              onClick={() => {
                                window.open(
                                  "https://allwellapp.com/free",
                                  "_self"
                                );
                                setTimeout(() => {
                                  this.setState({
                                    showInstallAppModal: false,
                                  });
                                }, 100);
                              }}
                            >
                              <img src={img_app_store} alt={img_app_store} />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </Modal>
          ) : null}
          <div className="navbarTop">
            <div className="navbarContent">
              {!this.props.lovedOneCountShow ? (
                <div className="leftData">
                  <div className="imgContent">
                    <img
                      className="logoImg"
                      src={AllWellLogoImg}
                      alt="All Well"
                      onClick={() =>
                        this.props.history.push({
                          pathname: PATHS.HOME,
                        })
                      }
                    />
                  </div>
                </div>
              ) : (
                <div className="leftData">
                  <div className="imgContent">
                    <img
                      className="logoImg"
                      src={AllWellLogoImg}
                      alt="All Well"
                      onClick={() =>
                        this.props.history.push({
                          pathname: PATHS.HOME,
                        })
                      }
                    />
                  </div>
                  <Divider orientation="vertical" flexItem />
                  <div className="infoText">
                    {Strings("myLovedOnes")}
                    <div className="userCount">
                      {this.props.summeryUserList &&
                        this.props.summeryUserList.length}
                    </div>
                  </div>
                </div>
              )}

              <div className="rightData">
                <div className="installAppBtn">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    onClick={() => this.setState({ showInstallAppModal: true })}
                  >
                    <div>{Strings("InstallApp")}</div>
                    <div>
                      <img src={ic_google_play} alt={ic_google_play} />
                    </div>
                    <div>
                      <img src={ic_app_store} alt={ic_app_store} />
                    </div>
                  </Button>
                  <div
                    className="logoutMobile"
                    onClick={() => {
                      this.setState({ showCustomModal: true });
                    }}
                  >
                    LOGOUT
                  </div>
                </div>

                {((this.props.userInfo && this.props.userInfo.first_name) ||
                  (this.props.userInfo && this.props.userInfo.last_name)) && (
                  <div className="rightData1">
                    <div className="profileNameCard">
                      <div className="profileName">
                        <span className="profileNameBold">
                          {this.first_name && this.full_name}
                        </span>
                      </div>
                      <div
                        className="profilLogout"
                        onClick={() => {
                          this.setState({ showCustomModal: true });
                        }}
                      >
                        LOGOUT
                      </div>
                    </div>

                    <div className="profileImgCard">
                      <div className="initialsCard">
                        <label>
                          {this.first_name && this.first_name[0].toUpperCase()}
                          {this.last_name && this.last_name[0].toUpperCase()}
                        </label>
                      </div>
                    </div>
                  </div>
                )}
                {/* for invited user */}
                {this.props.inviteTokenInfo &&
                  this.props.inviteTokenInfo.isInvitedUser && (
                    <div className="rightData1">
                      <div className="profileNameCard">
                      {this.invitedFirst_name && this.invitedFull_name}
                      </div>
                      <div className="profileImgCard">
                        <div className="initialsCard">
                          <label>
                            {this.invitedFirst_name &&
                              this.invitedFirst_name[0].toUpperCase()}
                            {this.invitedLast_name &&
                              this.invitedLast_name[0].toUpperCase()}
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(TopNavigationBar);
